import {ChildPortChunk} from "../chunks/types/ChildPortChunk";
import {ChildPortRef} from "./types/ChildPortRef";
import {getNameFromIdentifierChunk} from "./utils/getNameFromIdentifier";
import {getPortDirectionFromChildPortDirectionChunk} from "./utils/getPortDirectionFromChildPortDirectionChunk";

export function childPortChunkToChildPortRef(
  childPortChunk: ChildPortChunk
): ChildPortRef<any, any> {
  const {
    captures: {
      1: childNameChunk,
      2: childPortDirectionChunk,
      3: portNameChunk
    }
  } = childPortChunk;
  return {
    direction: getPortDirectionFromChildPortDirectionChunk(childPortDirectionChunk),
    childName: getNameFromIdentifierChunk(childNameChunk),
    portName: getNameFromIdentifierChunk(portNameChunk)
  };
}
